export enum QualiteOccupant {
  Proprietaire = "Propriétaire",
  Locataire = "Locataire",
}

export enum GdaTypes {
  Suspicion = 1,
  False_Positive = 2,
  Confirmed_Authorized = 3,
  Confirmed_Forbidden = 4,
  Error = 5,
}
